import { isPossiblePhoneNumber } from 'libphonenumber-js';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { toE164 } from '../../format/PhoneNumber';

type SearchAccountsProps = {
  forDarkNavbar?: boolean;
};

const SearchAccounts = ({ forDarkNavbar }: SearchAccountsProps) => {
  const [phoneSearch, setPhoneSearch] = useState('');

  const openAccount = (newTab: boolean) => {
    const formatted = toE164(phoneSearch);
    if (newTab) {
      window.open(`/account/${formatted}`, '_blank');
    } else {
      window.location.href = `/account/${formatted}`;
    }
  };

  const enableSearch =
    isPossiblePhoneNumber(phoneSearch) ||
    isPossiblePhoneNumber('+' + phoneSearch) ||
    isPossiblePhoneNumber('+1' + phoneSearch);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!enableSearch) {
      return;
    }
    const submitter = (e.nativeEvent as SubmitEvent).submitter as HTMLButtonElement | null;
    const newTab = submitter?.dataset.openNewTab === 'true';
    openAccount(newTab);
  };

  return (
    <Form
      className="d-flex align-items-center"
      style={{ minWidth: 200, maxWidth: 240, flex: '1 1 200px' }}
      data-bs-theme={forDarkNavbar ? 'dark' : undefined}
      onSubmit={handleSubmit}>
      <InputGroup size="sm" className="flex-nowrap">
        <Form.Control
          placeholder="Phone number"
          value={phoneSearch}
          id="page-phone-number-search"
          onChange={(e) => setPhoneSearch(e.target.value.replace(/[^+0-9]/g, ''))}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.altKey) {
              e.preventDefault();
              if (enableSearch) {
                openAccount(true);
              }
            }
          }}
        />
        <Button variant="primary" type="submit" disabled={!enableSearch} data-open-new-tab="false">
          <i className="fas fa-sm fa-search" />
        </Button>
        <Button variant="primary" type="submit" disabled={!enableSearch} data-open-new-tab="true">
          <i className="fas fa-sm fa-search-plus" />
        </Button>
      </InputGroup>
    </Form>
  );
};

export default SearchAccounts;
